export var DEFAULT_PAGE_SIZE = 50;
export var DEFAULT_PAGE_INFO = {
  rows: DEFAULT_PAGE_SIZE,
  start: 0,
  current: 1
};